import { render, staticRenderFns } from "./MilestonesList.vue?vue&type=template&id=4e75f8ce&"
import script from "./MilestonesList.vue?vue&type=script&lang=js&"
export * from "./MilestonesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e75f8ce')) {
      api.createRecord('4e75f8ce', component.options)
    } else {
      api.reload('4e75f8ce', component.options)
    }
    module.hot.accept("./MilestonesList.vue?vue&type=template&id=4e75f8ce&", function () {
      api.rerender('4e75f8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/MilestonesList.vue"
export default component.exports